import { create } from 'zustand'
import { persist, devtools } from 'zustand/middleware'
import { apiService } from '../services/api'

const useUserStore = create(
	persist(
		devtools((set, get) => ({
			token: null,
			user: { caseOpened: false },
			loading: false,
			error: null,

			// Авторизация — получает токен и пользователя
			auth: async () => {
				set({ loading: true, error: null })
				try {
					console.log('Вызов auth()...');
					const response = await apiService.auth()
					console.log('Ответ от auth:', response);

					const { token, user } = response;

					if (!token) throw new Error('Токен не получен');

					set({ token, user, loading: false });
					console.log('Установлен токен и пользователь:', { token, user });

					return { success: true };
				} catch (err) {
					console.error('Ошибка в auth:', err);
					set({ error: err.message || 'Ошибка авторизации', loading: false });
					return { success: false };
				}
			},

			// Получить данные пользователя по токену
			fetchUser: async () => {
				set({ loading: true, error: null });
				try {
					console.log('Вызов fetchUser()...');
					const res = await apiService.getMe();
					console.log('Ответ от getMe:', res);

					if (res.status === 'error') throw new Error(res.error || 'Ошибка при загрузке');

					set(state => {
						const userData = {
							...state.user,
							...res.data
						};
						if (typeof userData.caseOpened === 'undefined') userData.caseOpened = false;
						console.log('Установлен пользователь:', userData);
						console.log('createdAt в userData:', userData.createdAt);
						console.log('res.data:', res.data);
						return { user: userData, loading: false };
					});
				} catch (err) {
					console.error('Ошибка в fetchUser:', err);
					set({ error: err.message || 'Ошибка при загрузке', loading: false });
				}
			},

			logout: () => {
				console.log('Вызов logout()');
				set({ token: null, user: { caseOpened: false }, error: null })
			},

			// Получить актуальный баланс пользователя
			fetchBalance: async () => {
				try {
					const res = await apiService.getMe();
					if (res.status === 'error') throw new Error(res.error || 'Ошибка при загрузке');
					const userData = { ...res.data };
					if (typeof userData.caseOpened === 'undefined') userData.caseOpened = false;
					set({ user: userData });
					console.log('Баланс пользователя обновлён:', userData.balance);
				} catch (err) {
					console.error('Ошибка в fetchBalance:', err);
				}
			},

			clearToken: () => {
				console.log('Очистка токена в UserStore');
				set({ token: null });
			},
		})),
		{
			name: 'UserStore',
			partialize: (state) => ({ token: state.token }) // Сохраняем только токен в localStorage
		}
	)
)

export default useUserStore